"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M12.3667 5.77492C12.4833 6.24159 12.5417 6.76659 12.5417 7.29159C12.5417 10.4999 9.91667 13.1249 6.70833 13.1249C3.5 13.1249 0.875 10.4999 0.875 7.29159C0.875 4.08325 3.5 1.45825 6.70833 1.45825C7.81667 1.45825 8.86667 1.74992 9.8 2.33325",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.375 6.12484L6.70833 8.45817L13.125 2.0415",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;